module.exports = __webpack_public_path__ + "static/img/search.7e2cb306.png";